export default {
  'Text': 'Texto',
  'Styles': 'Estilos',
  'Text here': 'Texto aquí',
  'Add subtitles': 'Añadir subtítulos',
  'Text Color': 'Color de texto',
  'Outline': 'Marco',
  'Background': 'Fondo',
  'Position': 'Posición',
}